import { AuthId } from "@common/constans";
import { IDuplicateCheckRequest, IDuplicateCheckResponse } from "@common/models";
import { IPnrInfo } from "@common/models/PnrInfo";
import { IPnrInfoRequest } from "@common/models/PnrInfoRequest";
import { IRequest } from "@common/models/Request";
import { IReservationHistorySearchQuery } from "@common/models/ReservationHistorySearchQuery";
import { IResponse } from "@common/models/Response";
import { ISatisfaction } from "@common/models/Satisfaction";
import { IShareInitializeResponse } from "@common/models/ShareInitializeResponse";
import { ISharingRequest } from "@common/models/SharingRequest";
import { ISharingResponse } from "@common/models/SharingResponse";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function pnrInformation<T = IPnrInfoRequest, U = IPnrInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/pnr", {
                ...options,
                raiseError: options?.raiseError ?? true,
                captchaRequierd: options?.captchaRequierd ?? true,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function ticketInformation<T = IPnrInfoRequest, U = IPnrInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/Ticket", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}

export function initialShareTraveler<T = ISharingRequest, U = IShareInitializeResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/Share/Init", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? false
            });
    }
    return Promise.reject();
}

export function ShareTraveler<T = ISharingRequest, U = ISharingResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/Share/Submit", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? false
            });
    }
    return Promise.reject();
}

export function recentPnrInformation<T = IPnrInfoRequest, U = IPnrInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/pnr/recent", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function memberPnrInfo<T = IPnrInfoRequest, U = IPnrInfo>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/Member/Pnr", {
                ...options,
                raiseError: options?.raiseError ?? true,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function reservationHistory<T = IRequest<IReservationHistorySearchQuery>, U = IPnrInfo[]>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/Trips", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function upcomingTrips<T = IRequest<IReservationHistorySearchQuery>, U = IPnrInfo[]>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/Trips/Upcoming", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function upcomingCheckin<T = IRequest<IReservationHistorySearchQuery>, U = IPnrInfo[]>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/Trips/Checkin", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function duplicateCheck<T = IDuplicateCheckRequest, U = IDuplicateCheckResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/DuplicateCheck", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function AllowAddMyTrip<T = IPnrInfoRequest, U = boolean>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/AllowAddMyTrip", {
                ...options,
                raiseError: options?.raiseError ?? false,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function AddMyTrips<T = IPnrInfoRequest, U = boolean>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/AddMyTrips", {
                ...options,
                raiseError: options?.raiseError ?? false,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking,
                callBackTrigger: options?.callBackTrigger ?? true
            });
    }
    return Promise.reject();
}

export function rateUs<T = ISatisfaction, U = boolean>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Reservation/Satisfaction", {
                ...options,
                raiseError: options?.raiseError ?? false,
                authenticationId: options?.authenticationId ?? AuthId.ManageBooking
            });
    }
    return Promise.reject();
}
